import React, {useEffect} from 'react';
import {images} from '../../../../../assets/icons';
import {Props} from './model';
import {TouchableOpacity, View, StyleSheet} from 'react-native';
import {useStyles} from '../../../../../shared/hooks/styles';
import {HolderAvatar} from '../../../../../shared/components/holderAvatar';
import {NameInfoAccordion} from '../nameInfoAccordion';
import {Text} from '../../../../../shared/components/text';
import {useAccountLinker} from '../../../../../shared/hooks/useAccountLinkerHook/useAccountLinker';
import {NameInfoText} from '../nameInfoText';
import {getTokenForLinkedAccount} from '../../../../../shared/hooks/useAccountLinkerHook/api';
import {useSelector} from 'react-redux';
import {useAppDispatch} from '../../../../../redux';
import {holderProfileSelector} from '../../../../../redux/selectors/profile';
import {capitalizeLastWord} from '../../../../../shared/utils/text';

const NameCard = (props: {id?: number; fullName: string; isParentAccount?: boolean}) => {
  const {id, fullName} = props;
  const dispatch = useAppDispatch();
  const {switchToLinkedAccount, setParentAccount, parentAccount, linkedAccounts} = useAccountLinker();
  const profile = useSelector(holderProfileSelector());
  const styles = useStyles(({theme}) => ({
    menuElement: {
      display: 'flex',
      flexDirection: 'row',
      paddingHorizontal: 16,
      paddingVertical: 20,
      backgroundColor: theme.color.grayMenu,
      marginHorizontal: 16,
      marginVertical: 6,
      borderRadius: 14,
      justifyContent: 'space-between',
      width: '100%',
      alignSelf: 'center',
    },
    title: {
      flexGrow: 0,
      flexShrink: 1,
    },
    arrowColor: {
      color: theme.color.textColor,
    },
    arrow: {
      flexBasis: 24,
      flexGrow: 0,
      flexShrink: 0,
      height: theme.fonts.h6Light.lineHeight,
      justifyContent: 'center',
    },
  }));

  const isLinkedAccountCardActivated = () => {
    if (id) return linkedAccounts.filter((acc) => acc.id === id && acc.cardStatusId === 2).length > 0;
    return true;
  };

  const handlePress = async () => {
    if (!isLinkedAccountCardActivated()) return;
    const tokenToReplace =
      props.isParentAccount && parentAccount?.token
        ? parentAccount.token // necessary to cover with quotes to be properly saved in storage
        : id
        ? (await getTokenForLinkedAccount(id.toString())).token
        : null;
    if (!tokenToReplace) return;

    if (!props.isParentAccount) await setParentAccount(profile?.displayName || 'Родительский профиль');
    switchToLinkedAccount(tokenToReplace, dispatch);
  };
  return (
    <TouchableOpacity
      testID={`profile-mobile-menu-item--link-id`}
      style={styles.menuElement}
      onPress={handlePress}
      accessibilityRole='link'>
      <Text type='h6Light' style={styles.title}>
        {fullName}
      </Text>
      <View style={styles.arrow}>
        <images.Right width={24} height={24} color={StyleSheet.flatten(styles.arrowColor).color} />
      </View>
    </TouchableOpacity>
  );
};

export default (props: Props) => {
  const {name, testID} = props;
  const styles = useStyles(({theme}) => {
    return {
      action: {
        ...theme.fonts.h6,
        textAlign: 'center',
      },
      container: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: theme.color.primaryNonGreyBackground,
        paddingTop: 24,
        paddingHorizontal: 0,
        paddingBottom: 16,
      },
      image: {marginBottom: 20},
    };
  });
  const {linkedAccounts, getParentAccount, parentAccount} = useAccountLinker();

  useEffect(() => {
    getParentAccount();
  }, []);

  const linkedAccountsToSwitch = linkedAccounts.filter(
    (account) => account.isCardHolderParent === false && account.status === 'Accepted',
  );

  return (
    <View testID={testID} style={styles.container}>
      {linkedAccountsToSwitch.length !== 0 || parentAccount != null ? (
        <>
          <HolderAvatar style={styles.image} size={100} />
          <NameInfoAccordion title={name}>
            <View testID='profile-menu-id' style={{width: '100%', display: 'flex', marginTop: 8, flex: 1}}>
              {parentAccount != null && <NameCard fullName={parentAccount.fullName} isParentAccount />}
              {linkedAccountsToSwitch.map((account, index) => {
                return (
                  <NameCard fullName={capitalizeLastWord(account.counterpartyFullName)} id={account.id} key={index} />
                );
              })}
            </View>
          </NameInfoAccordion>
        </>
      ) : (
        <NameInfoText name={name} testID='testID' />
      )}
    </View>
  );
};
